const sectionAnimation = () => {
    const sections = document.querySelectorAll('[data-animate]');  
    
    sections.forEach(section => {
      const halfWindow = window.innerHeight * 0.6;
      const isSectionVisible = (section.getBoundingClientRect().top - halfWindow) < 0;
  
      if(isSectionVisible) {
        section.setAttribute("data-animate", "true");
      }
    });  
  }
  
  window.addEventListener('scroll', sectionAnimation); 
 
  /**
 * Tooltip.
 * Prevent the tooltip from appearing off-screen when the user clicks or hovers over it.
 */

const setTooltipPosition = () => {
  const tooltips = document.querySelectorAll('.tooltip');

  const handleTooltip = (element, event) => {
    element.classList.remove('tooltip--right');
    element.classList.remove('tooltip--center');

    if (event.pageX + 220 > window.innerWidth) {
      element.classList.add('tooltip--right');
    } else {
      element.classList.add('tooltip--center');
    }
  };

  tooltips.forEach((tooltip) => {
    tooltip.addEventListener('mouseenter', (event) => handleTooltip(tooltip, event));
    tooltip.addEventListener('click', (event) => handleTooltip(tooltip, event));
  });
};

document.addEventListener('DOMContentLoaded', setTooltipPosition);
  